import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';
import { User } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import {Observable, Subscription} from 'rxjs';
import { filter } from 'rxjs/operators';
import {ActiveCartService} from '@spartacus/cart/base/core';
import {CartTotalsComponent} from '@spartacus/cart/base/components';
import { OrderEntry } from '@spartacus/cart/base/root';

@Component({
    selector: 'app-uig-cart-totals',
    templateUrl: './uig-cart-totals.component.html',
    styleUrls: ['./uig-cart-totals.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCartTotalsComponent extends CartTotalsComponent implements OnDestroy{

  isRestricted: boolean = false;
  RIO_CART_ORDER: string = "rio_cart_order";
  roles: string[];
  private userSubscription = new Subscription();
  entries$: Observable<OrderEntry[]>;

  constructor(
    protected activeCartService: ActiveCartService,
    protected userAccountFacade: UserAccountFacade
    ) {
    super(activeCartService);
    this.checkForRoles();
  }
  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }
  ngOnInit() {
    super.ngOnInit();
    this.entries$ = this.activeCartService
        .getEntries()
        .pipe(filter((entries) => entries.length > 0))
  }

  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && user.roles.includes(this.RIO_CART_ORDER);
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }
}
